import { templateFolder } from "@rezonence/freewall-templates";

export const templateBucket = templateFolder;